<template>
    <div class="type-g" :style="{ backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : ''}">
        <typeGImage v-show="!backgroundUrl"></typeGImage>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import typeGImage from './typeGImage.vue';

const props = defineProps({
    paramsBg: {
        type: String,
        required: true
    }
})
const imageUrlList = []
// const paramsBg = 'buccalGingival';
const backgroundUrl = ref('');
// const backgroundUrl = computed(() => imageUrlList.includes(props.paramsBg) ? require(`./${props.paramsBg}.svg`) : '');
const backgroundClass = ref('buccalGingival');
</script>

<style lang="scss" scoped>
.type-g{
    width: 100%;
    height: 100%;
    background-size: 100% 100% !important;
}
// .buccalGingival{
//     background: url(./buccalGingival.png);
// }
</style>